import { Icon } from "."

import styles from "./Flow.module.scss"

import type { LineProps } from "./Flow.types"

export const Line = (props: LineProps) => {
  const { isFalsePositive } = props

  return (
    <div className={styles.line}>
      <div className={styles.numberWrapper}>
        <Icon isFalsePositive={isFalsePositive} />
      </div>
    </div>
  )
}
